// components/MarginAndFundsCard.jsx
import React from 'react';

const MarginAndFundsCard = ({
    marginRequired,
    finalMargin,
    hedgeBenefits,
    marginAvailable,
    formatNumberWithCommasAndFontWeight,
}) => {
    const formatWithFallback = (value) => {
        if (value === null || value === undefined || isNaN(value)) return <span>--</span>;
        return (
            <span>
                ₹ {formatNumberWithCommasAndFontWeight(value)}
            </span>
        );
    };

    return (
        <div className="flex flex-col justify-between rounded-md bg-p400 text-p300 shadow-sm">
            <div className="text-[14px] font-semibold text-p300 p-4 pb-2">Margin & Funds</div>

            <div className="flex justify-between items-center px-4 pb-4 border-b border-n100">
                <div className="flex flex-col">
                    <span className="text-[12px] text-n400">Required Margin</span>
                    <span className="text-[14px] font-medium">
                        {formatWithFallback(marginRequired)}
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-[12px] text-n400">Final Margin</span>
                    <span className="text-[14px] font-medium">
                        {formatWithFallback(finalMargin)}
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-[12px] text-n400">Hedge Benefits</span>
                    <span className="text-[14px] font-medium">
                        {formatWithFallback(hedgeBenefits)}
                    </span>
                </div>
            </div>

            <div className="flex justify-between items-center px-4 pt-2 pb-4 bg-n000 rounded-b-md">
                <div className="flex flex-col">
                    <div className="text-[14px] font-medium">Margin Available</div>
                    <div className=" text-[12px] text-n400">(Funds available to trade)</div>
                </div>
                <div className="text-base font-medium">
                    {formatWithFallback(marginAvailable)}
                </div>
            </div>
        </div>
    );
};

export default MarginAndFundsCard;
